import React from 'react';
// @ts-ignore
import styles from './WorkplaceOrWorkplaceMemberSelectItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';

type Workplace = {
	id: string;
	doctorDisplayName: string;
	rootWorkplace?: {
		id: string;
		doctorDisplayName: string;
	};
};

type WorkplaceMember = {
	id: string;
	user: {
		id: string;
		profile: {
			fullName: string;
		};
	};
	workplace: Workplace;
	hasShiftNow: boolean;
};

interface Props {
	onSelect: (id: string, label: string, item: WorkplaceMember) => void;
	item: WorkplaceMember;
}

const WorkplaceOrWorkplaceMemberSelectWorkplaceMemberItem: React.FC<Props> = ({
	item,
	onSelect,
}) => {
	const handleSelect = () => {
		onSelect(item.id, item.user.profile.fullName, item);
	};

	return (
		<div className={styles.wrapper} onClick={handleSelect}>
			<div className={styles.header}>
				<div className={styles.nameWrapper}>
					<div className={styles.title}>{item.user?.profile.fullName}</div>
					{item.hasShiftNow && (
						<Text className={styles.hasShift} tx='base.hasShift' />
					)}
				</div>
			</div>
			<div className={styles.content}>
				<Text tx='base.shared.workplace' firstUpper inline />:{' '}
				{item.workplace.rootWorkplace &&
					item.workplace.rootWorkplace.doctorDisplayName}
				, {item.workplace.doctorDisplayName}
			</div>
		</div>
	);
};

export default WorkplaceOrWorkplaceMemberSelectWorkplaceMemberItem;
